import React, { useRef, useState } from "react";
import Keyboard from "react-simple-keyboard";
// @ts-ignore
import "react-simple-keyboard/build/css/index.css";
import { KeyboardWrapper } from "./CustomKeyboardStyles";

interface Props {
  setValue: (value: string) => void;
  type?: "text" | "number" | "email";
}

function CustomKeyboard({ setValue, type }: Props) {
  const [layout, setLayout] = useState("default");
  const keyboard = useRef<any>(null);

  const onChange = (input: any) => {
    setValue(input);
  };

  const handleShift = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
  };

  const onKeyPress = (button: any) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const layoutTypes = {
    text: {
      default: [
        "1 2 3 4 5 6 7 8 9 0",
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "Z X C V B N M {bksp}",
      ]
    },
    number: {
      default: [
        "1 2 3",
        "4 5 6",
        "7 8 9",
        "0 {bksp}"
      ]
    }
  };

  return (
    <KeyboardWrapper>
      <Keyboard
        keyboardRef={(r) => (keyboard.current = r)}
        layoutName={layout}
        layout={
          type === "text"
            ? layoutTypes.text
            : type === "number"
              ? layoutTypes.number
              : undefined
        }
        onChange={onChange}
        onKeyPress={onKeyPress}
        display={{
          "{bksp}": "⌫",
          "{enter}": "⏎",
          "{space}": " ",
          "{shift}": "⇧",
          "{lock}": "⇪",
          "{tab}": "⇥"
        }}
      />
    </KeyboardWrapper>
  );
}

export default CustomKeyboard;
